
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import AppOverAllAssessmentListingFilterHeader from "@/components/recruiter/app_assessment/AppOverAllAssessmentListingFilterHeader.vue";
import { FETCH_OVERALL_ASSESSMENTS } from "@/store/modules/recruiter/constants";
import {
  format_date,
  get_color_for_percentage,
  get_pass_or_fail_class,
  assessment_pass_fail_result,
  get_app_assessment_status_color,
  get_app_assessment_status
} from "@/utils/global";
import { calculateEnglishAssessmentScore } from "@/utils/assessment.utils";
import moment from "moment";

export default Vue.extend({
  name: "AppSummaryAssessmentReport",
  components: {
    GoBackHeader,
    AppOverAllAssessmentListingFilterHeader
  },
  data() {
    return {
      headers: [
        { text: "Candidate Name", value: "first_name" },
        { text: "English Assessment Score", value: "english_assessment" },
        { text: "English Assessment Status", value: "english_status" },
        { text: "English Assessment Taken Date/Time", value: "english_date" },
        { text: "Additional Assessment Score", value: "ai_assessment" },
        { text: "Additional Assessment Status", value: "ai_status" },
        { text: "Additional Assessment Taken Date/Time", value: "ai_date" }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters("recruiter", {
      overall_assessment_details: FETCH_OVERALL_ASSESSMENTS
    })
  },
  async mounted() {
    await this.process_assessment_listing();
  },
  methods: {
    format_date,
    get_color_for_percentage,
    get_pass_or_fail_class,
    assessment_pass_fail_result,
    get_app_assessment_status_color,
    get_app_assessment_status,
    ...mapActions("recruiter", {
      fetch_overall_assessments: FETCH_OVERALL_ASSESSMENTS
    }),
    async process_assessment_listing() {
      this.loading = true;
      await this.fetch_overall_assessments(this.overall_assessment_details);
      this.loading = false;
    },
    async export_report() {
      const payload = {
        ...this.overall_assessment_details,
        download_report: true
      };
      const reportUrl = await this.fetch_overall_assessments(payload);
      if (typeof reportUrl !== "string" || !reportUrl) return;
      // Use a temporary link so the browser goes straight to the file (no about:blank tab)
      const a = document.createElement("a");
      a.href = reportUrl;
      a.rel = "noopener noreferrer";
      a.target = "_blank";
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    get_date(date: string) {
      if (date) return format_date(date);
      return "N/A";
    },

    get_date_time(date: string) {
      if (date) return moment(date).format("MMM DD, YYYY HH:mm");
      return "N/A";
    },
    parse_json(val: string) {
      if (!val) return null;
      try {
        return JSON.parse(val);
      } catch (e) {
        return null;
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    calculate_english_score(result: any) {
      return calculateEnglishAssessmentScore(result);
    }
  }
});
